<template>
  <div class="color-control">
    <Dropdown :dataset="currentValue" @change="change" @visible-change="visibleChange" :disabled="disabled">
      <template slot-scope="data">
        <span class="el-dropdown-link">
          <img :src="data.selectColor.backGroundMini" alt="">
          <i class="icon iconfont iconicon_arrow_task icon" :class="{'show': show}" v-if="!disabled"></i>
        </span>
      </template>
    </Dropdown>
  </div>
</template>
<script>
import Dropdown from './dropdown'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    defaultText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Dropdown
  },
  data() {
    return {
      selectColor: {},
      show: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    currentValue: {
      get() {
        if(this.dataset) {
          let arr = this.dataset
          arr.background_text = this.getText()
          return arr
        } else {
          return {}
        }
      }
    }
  },
  methods: {
    getText() {
      if(this?.dataset?.background_text) {
        return this?.dataset?.background_text
      } else if(this.defaultText) {
        return this.defaultText.slice(0, 8)
      } else {
        return ''
      }
    },
    change(val) {
      this.selectColor = val
      this.$emit('change', {...this.dataset, ...val})
    },
    visibleChange(val) {
      this.show = val
    }
  }
}
</script>
<style lang="scss">
.color-control {
  .el-dropdown-link {
    display: flex;
    align-items: center;
    // cursor: pointer;
    img {
      margin-right: 9px;
      width: 32px;
      height: 32px;
      border-radius: 6px;
    }
    i {
      color: rgba(32, 32, 32, 0.6);
      font-size: 12px;
      transition: all .3s;
    }
    .show {
      transform: rotate(180deg);
    }
  }
}
</style>
